export default __webpack_public_path__ + "static/media/menu_lesson.0c75fd3f.jpg";